import { useTranslation } from 'react-i18next'
import { M_Fieldset } from 'src/M_Components'
import { ShipmentChargesFormField } from './ShipmentChargesFormField'

export const ShipmentChargesRemarks = ({ dataState, setDataState, disabled }) => {
    const { t } = useTranslation()

    const remarksFields = [
        {
            display: t('LogisticRemarks'),
            code: 'LogisticRemarks',
            type: 'textArea',
        },
        {
            display: t('SalesRemarks'),
            code: 'SalesRemarks',
            type: 'textArea',
        },
        {
            display: t('Remarks'),
            code: 'Remarks',
            type: 'textArea',
        },
    ]

    return (
        <M_Fieldset
            labelInside
            style={{ width: '100%', boxSizing: 'border-box' }}
            label={
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '20px', marginLeft: '10px' }}>
                    <i className='pi pi-comment' style={{ fontSize: '18px' }} />
                    {t('Remarks')}
                </div>
            }
            elements={
                <div style={{ display: 'flex', flexDirection: 'row', padding: '10px', gap: '5px' }}>
                    {remarksFields.map((field, index) => (
                        <div key={index} style={{ flex: 1, minWidth: 0 }}>
                            <ShipmentChargesFormField
                                fields={{ ...field, rows: 3 }}
                                index={index}
                                data={dataState}
                                setData={setDataState}
                                size='100%'
                                disabled={disabled}
                            />
                        </div>
                    ))}
                </div>
            }
        />
    )
}
